<template>
  <ModalBase :state="state" :open="open" :close="close">
    <template #content>
      <div class="pb-24 pl-8 pr-8">
        <div class="text-pararaphy-1 flex flex-col gap-12">
          <p class="text-title-3">{{ $t("attention.attention_1") }}</p>

          <p>{{ $t("attention.attention_2") }}</p>
          <p>{{ $t("attention.attention_3") }}</p>
          <p>{{ $t("attention.attention_4") }}</p>
          <p>{{ $t("attention.attention_5") }}</p>
        </div>
      </div>
      <div class="flex flex-row-reverse">
        <OButton
          size="md"
          class="w-[161px] h-[44px] bg-primary-pure rounded-lg"
          color=""
          :label='$t("attention.btn")'
          @click="closeModal"
        />
      </div>
    </template>
  </ModalBase>
</template>

<script setup>
import { i18n } from 'js/vue/i18n'
import { modalAtencaoService } from 'js/vue/services/modalAtencao.service'
import { onMounted, watch } from 'vue'
import { useCookies } from '@vueuse/integrations/useCookies'
import { useI18n } from 'vue-i18n'
import ModalBase from './ModalBase.vue'
import OButton from 'components/Button/OButton.vue'
import useModal from 'composables/useModal'

const { t, locale } = useI18n()

const modalAtencao = useModal({
  style: { width: '802px' },
})

const { state, open, close } = modalAtencao

const closeModal = () => {
  close()
}

// const { getModalAtencao } = modalAtencaoService()

// onMounted(async () => {
//   const { results } = await getModalAtencao()
// })

watch(
 () => i18n.global.availableLocales.includes(locale.value),
 () => {
   modalAtencao.setState({
     header: { title: t('attention.tittle') },
   })
 },
 { immediate: true }
)

defineExpose({
  state,
  open,
  close,
})
</script>

<style lang="scss" scoped></style>
